(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["multi-column"] && !window.DesignMode) return;
  try {
    
  function removeDuplicateModals() {
    var modals = document.querySelectorAll('#playlist-modal');
    if (modals.length > 1) {
      for (var i = 1; i < modals.length; i++) {
        modals[i].parentNode.removeChild(modals[i]);
      }
    }
  }

  function createAndInsertYouTubeIframe(videoUrl) {
    removeDuplicateModals();

    var iframe = document.createElement('iframe');

    iframe.id = 'ytplayer';
    iframe.type = 'text/html';
    iframe.width = '549';
    iframe.height = '300.13';
    iframe.src = videoUrl;
    iframe.frameBorder = '0';

    if (window.screen.width < 568) {
      iframe.width = '365.79';
      iframe.height = '200.28';
    }

    if (window.screen.width < 400) {
      iframe.width = '320';
      iframe.height = '180';
    }

    var targetDiv = document.getElementById('playlist-modal__video-target');

    if (targetDiv) {
      targetDiv.innerHTML = '';
      targetDiv.appendChild(iframe);
    }

    var modal = document.getElementById('playlist-modal');
    if (modal) {
      modal.classList.add('open');
    }
  }

  function handlePlaylistClick(event) {
    event.preventDefault();
    var videoUrl = this.href;
    createAndInsertYouTubeIframe(videoUrl);
  }

  function handlePlaylistCloseClick(event) {
    event.preventDefault();
    var modal = document.getElementById('playlist-modal');
    var targetDiv = document.getElementById('playlist-modal__video-target');
    if (targetDiv) {
      targetDiv.innerHTML = '';
    }
    if (modal) {
      modal.classList.remove('open');
    }
  }

  function handleModalBackgroundClick(event) {
    var modal = document.getElementById('playlist-modal');
    var targetDiv = document.getElementById('playlist-modal__video-target');
    if (event.target.classList.contains('open')) {
      if (modal) {
        modal.classList.remove('open');
      }
      if (targetDiv) {
        targetDiv.innerHTML = '';
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var playlistItems = document.querySelectorAll('.has-playlist');
    playlistItems.forEach(function (item) {
      item.addEventListener('click', handlePlaylistClick);
    });

    var modalCloseItems = document.querySelectorAll('.playlist-modal__close');
    modalCloseItems.forEach(function (item) {
      item.addEventListener('click', handlePlaylistCloseClick);
    });

    var modals = document.querySelectorAll('#playlist-modal');
    modals.forEach(function (item) {
      item.addEventListener('click', handleModalBackgroundClick);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
